import { Button, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

const CopyData = ({ item }) => {
  return (
    <Button
      type="text"
      style={{display: 'inline'}}
      icon={<CopyOutlined />}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        navigator.clipboard.writeText(item);
        message.success('Skopiowano do schowka');
      }}
    />
  );
};

export default CopyData;